<template>
    <div>
        <div class="ul-top box-sizing">
            <div class="ul-item">
                <span class="lab">时间：</span>
                <span class="opt">
                    <el-date-picker
                            v-model="timeGroup"
                            type="daterange"
                            unlink-panels
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :editable="false"
                            :picker-options="pickerOptions"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </span>
                <span class="lab">关键词：</span>
                <span class="opt"><el-input class="inp" placeholder="请输入小程序名称" v-model="keyword" clearable></el-input></span>
                <span class="btn"><el-button type="primary" @click="getXcxList">搜索</el-button></span>
            </div>
            <div class="btn-features">
                <el-button type="success" @click="showAddXcxDialog">生成链接</el-button>
                <el-popconfirm title="确定删除选中的小程序吗？" @confirm="del" style="margin-left: 10px">
                    <el-button type="danger" slot="reference">删除选中</el-button>
                </el-popconfirm>
                <el-button type="primary" style="margin-left: 10px;" @click="$router.push('/tabs/xcx/index')">小程序管理</el-button>
            </div>
        </div>
      <div class="su-mid box-sizing">
        <el-table  :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="42"></el-table-column>
          <el-table-column label="添加日期" width="110">
            <template slot-scope="scope">
              <div class="lim text-align exc_color" v-if="scope.row.is_exclusive">
                <i class="iconfont iconhuiyuanjulebu"></i>专属域名
              </div>
              <div class="lim">{{ scope.row.create_time }}</div>
            </template>
          </el-table-column>
          <el-table-column label="网址">
            <template slot-scope="scope">
              <div :title="scope.row.title">{{scope.row.title}}</div>
              <div class="lim">

                <div class="l">
                  <span>短：</span>
                  <a class="links" :href="scope.row.new_url" target="_blank">{{ scope.row.new_url }}</a>
                </div>
                <div class="r">
                  <el-link type="primary" @click="copyUrl(scope.row.new_url)">复制</el-link>
                </div>
              </div>
              <div class="lim">
                <div class="l">
                  <span>原：</span>
                  <a class="links" :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
                </div>

              </div>
              <div class="lim">
                <div class="l gray999">
                  小程序路径： {{scope.row.path}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="二维码" width="75" class-name="text-align">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="点击查看二维码" placement="top">
                <i class="icon iconfont iconerweima" @click="showQrCode(scope.row.new_url)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="pv" label="PV" width="75" class-name="text-align"></el-table-column>
          <el-table-column prop="uv" label="UV" width="75" class-name="text-align"></el-table-column>
          <el-table-column prop="ip" label="IP" width="75" class-name="text-align"></el-table-column>
          <!--        <el-table-column label="分类" width="120" class-name="text-align">-->
          <!--          <template slot-scope="scope">-->
          <!--            <span v-if="scope.row.labelName" class="class"-->
          <!--                  @click="editClass(scope.row.id)">{{ scope.row.labelName }}</span>-->
          <!--            <i v-else class="class icon el-icon-edit-outline" @click="editClass(scope.row.id)"></i>-->
          <!--          </template>-->
          <!--        </el-table-column>-->
          <!--      修改活码名称-->

          <el-table-column label="备注" width="120" class-name="text-align">
            <template slot-scope="scope">
              <el-tooltip effect="dark" content="点击修改备注" placement="top">
                <div class="link-mark" @click="editMark(scope.row)">{{ scope.row.mark }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="148">
            <template slot-scope="scope">
              <div class="text-center">
                <router-link class="opt-link" :to="'/tabs/manage/'+scope.row.lid">管理</router-link>
                <!--              <router-link class="opt-link" :to="'/tabs/advanced/'+scope.row.id">高级功能</router-link>-->
                <router-link class="opt-link" :to="'/tabs/channel/'+scope.row.id">渠道管理</router-link>
                <a class="opt-link" :href="'/statistics/'+scope.row.id" target="_blank">数据统计</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagebar" v-show="total>0">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="total"
                         @current-change="handleCurrentPage"></el-pagination>
        </div>
      </div>

      <!--查看二维码-->
      <el-dialog title="查看二维码" :visible.sync="qrCodeDialog" center :destroy-on-close="true" :modal-append-to-body="false"
                 width="400px">
            <span>
                <div class="link-qr-code" ref="qrCodeDiv"></div>
            </span>
        <span slot="footer">
                <el-button type="primary" @click="savePic">下载二维码</el-button>
            </span>
      </el-dialog>

      <el-dialog title="创建短链接" :visible.sync="addXcxDialog" center width="400px">
            <span>
                <el-form :model="xcxData" :rules="XcxRules" ref="XcxForm">

                  <el-form-item label="选择专属域名" >
                        <el-select v-model="xcxData.exc_domain_id" filterable  clearable placeholder="请选择"  @visible-change="getDomainList" style="width:100px;">
                            <el-option v-for="item in exc_domian_options"  :key="item.id" :label="item.domain" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                   <el-form-item label="选择小程序" prop="xcx_id">
                       <el-select v-model="xcxData.xcx_id" clearable placeholder="请选择" class="inp">
                          <el-option v-for="item in tableData2" :key="item.id" :label="item.name" :value="item.id"></el-option>
                       </el-select>

                    </el-form-item>
                    <el-form-item label="备注" prop="mark">
                        <el-input v-model="xcxData.mark"></el-input>
                    </el-form-item>
                  <el-form-item label="页面路径"  prop="path">
                        <el-input v-model="xcxData.path" placeholder="例如：pages/indnex/index?id=2"></el-input>
                    </el-form-item>

                </el-form>
            </span>
            <span slot="footer">
                <el-button @click="addXcxDialog=false">取消</el-button>
                <el-button type="primary" :loading="addXcxLoad" @click="addXcx">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from "qrcodejs2";

    export default {
        name: "UserXcx",
        data() {
            return {
                total: 0,
                keyword: "",
                selUrlID: "",
                timeGroup: [],
                tableData: [],
                isLoading: false,
                currentPage: 1,
                addXcxLoad: false,
                addXcxDialog: false,

              qrCodeDialog: false,

              exc_domian_options:[],
                xcxData: {
                    id: 0,
                    name: "",
                    mark: "",
                     path:'',
                  xcx_id:0,
                  exc_domain_id:'',
                },
                XcxRules:{
                    path: [
                        { required: true, message: '请输入小程序页面路径', trigger: 'blur' },
                    ]
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        mounted() {
          this.getList();
          this.getXcxList();
        },
        methods: {
          async getDomainList(val) {
            if (!val) return;
            if (this.isLoad) return;
            const {ret,msg,data} = await this.$api.exclusive.getUserList();
            if (ret === 1000){
              this.exc_domian_options = data.list;
            }
          },
          async getList() {
            this.isLoading = true;
            let start = 0;
            let end = 0;
            if (this.timeGroup === null) this.timeGroup = [];
            if (this.timeGroup.length === 2){
              start = this.timeGroup[0];
              end = this.timeGroup[1];
            }
            const getData = {
              start: Number(start/1000),
              end: Number(end/1000),
              keyword: this.keyword,
              p: this.currentPage,
            };
            const {ret,data} = await this.$api.xcxLink.getList(getData);
            this.isLoading = false;
            if (ret === 1000){
              this.total = Number(data['total']);
              this.tableData = data['list'];
              if(this.tableData.length>0){
                this.xcxData.xcx_id=this.tableData[0].id;console.log(this.tableData[0].id)
              }

            }
          },
            async getXcxList() {
                this.isLoading = true;
                let start = 0;
                let end = 0;
                if (this.timeGroup === null) this.timeGroup = [];
                if (this.timeGroup.length === 2){
                    start = this.timeGroup[0];
                    end = this.timeGroup[1];
                }
                const getData = {
                };
                const {ret,data} = await this.$api.xcx.getList(getData);
                if (ret === 1000){
                    this.tableData2 = data['list'];
                    if(this.tableData2.length>0){
                       this.xcxData.xcx_id=this.tableData2[0].id;
                    }

                }
            },
            addXcx() {
                const $this = this;
                $this.addXcxLoad = true;
                $this.$refs.XcxForm.validate(async (valid) => {
                    if (valid) {
                        let postData = {
                            id: $this.xcxData.id,
                            path: $this.xcxData.path,
                            mark: $this.xcxData.mark,
                            xcx_id: $this.xcxData.xcx_id,
                          exc_domain_id:$this.xcxData.exc_domain_id,
                        };
                        const {ret} = await $this.$api.xcxLink.update(postData);
                        $this.addXcxLoad = false;
                        if (ret === 1000){
                            $this.addXcxDialog = false;
                            $this.$message.success("添加成功！");
                            await $this.getList();
                        }
                    }else {
                        $this.addXcxLoad = false;
                    }
                });
            },
            del(id) {
                let ids = "";
                if (id){
                    ids = id;
                }else {
                    ids = this.selUrlID;
                }
                if (ids === ""){
                    this.$message.error("请选择要删除的小程序！");
                    return;
                }
                this.$confirm('此操作将永久删除该小程序, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const {ret} = await this.$api.xcx.del({ids:ids});
                    if (ret === 1000){
                        this.getXcxList();
                        this.$message.success("删除成功！");
                    }
                });
            },
            editXcx(item){
                this.xcxData.id = item.id;
                this.xcxData.name = item.name;
                this.xcxData.mark = item.mark;
              this.xcxData.appid = item.appid;
              this.xcxData.appsecret = item.appsecret;
                this.addXcxDialog = true;
            },
            showAddXcxDialog() {
                this.xcxData.id = 0;
                this.xcxData.name = "";
                this.xcxData.mark = "";
                this.addXcxDialog = true;
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getXcxList();
            },
            handleSelectionChange(val) {
                if (val.length === 0){
                    return;
                }
                let ids = "";
                for (const item of val){
                    ids += item.id+",";
                }
                ids = ids.substr(0,ids.length-1);
                this.selUrlID = ids;
            },
          showQrCode(txt) {
            if (txt === '') {
              this.$message.error('出错了！刷新试试看！');
              return;
            }
            this.qrCodeDialog = true;
            const $this = this;
            setTimeout(function () {
              $this.$refs.qrCodeDiv.innerHTML = '';
              new QRCode($this.$refs.qrCodeDiv, {
                text: txt,
                width: 200,
                height: 200,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
              });
            }, 100);
          },
          savePic() {
            let myQrCode = this.$refs.qrCodeDiv.getElementsByTagName('canvas');
            let a = document.createElement('a');
            a.href = myQrCode[0].toDataURL('image/png');
            a.download = 'linkQrCode';
            a.click();
          },
        }
    }
</script>

<style scoped>
    .ul-top{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .ul-top .ul-item{
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }
    .ul-top .ul-item .lab{
        display: inline-block;
        width: 70px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .opt{
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }
    .ul-top .ul-item .btn{
        display: inline-block;
        width: 70px;
        height: 40px;
        margin-left: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .inp{
        width: 350px;
    }
    .ul-top .btn-features{
        width: 100%;
        height: 40px;
        margin-top: 30px;
    }
    .ul-mid{
        width: 100%;
        padding: 0 20px;
    }
    .ul-mid .pagebar{
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }
</style>

<style scoped>
.su-top {
  width: 100%;
  height: auto;
  padding: 20px;
}

.su-top .su-item {
  width: 100%;
  height: 40px;
  color: #666666;
  margin-bottom: 10px;
}

.su-top .su-item .lab {
  display: inline-block;
  width: 80px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
  margin-right: 10px;
  vertical-align: top;
}

.su-top .su-item .opt {
  display: inline-block;
  width: 350px;
  height: 40px;
  vertical-align: top;
}

.su-top .su-item .inp {
  width: 350px;
}

.su-top .btn-features {
  width: 100%;
  height: 40px;
  margin-top: 30px;
}

.su-mid {
  width: 100%;
  padding: 0 20px;
}

.su-mid .lim {
  width: 100%;
  height: 24px;
}

.su-mid .lim .l {
  display: inline-block;
  width: 242px;
  height: 24px;
  overflow: hidden;
  vertical-align: top;
}

.su-mid .lim .l .links {
  display: inline-block;
  /*width: 214px;*/
  height: 24px;
  color: #409EFF;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: top;
}

.su-mid .lim .l .links:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.su-mid .lim .r {
  display: inline-block;
  width: 28px;
  height: 24px;
  cursor: pointer;
  margin-left: 10px;
  vertical-align: top;
}

.su-mid .icon {
  cursor: pointer;
  font-size: 28px;
}

.su-mid .icon:hover {
  color: #409EFF;
}

.su-mid .class {
  color: #409EFF;
  cursor: pointer;
}

.pagebar {
  width: 100%;
  height: 52px;
  margin-top: 20px;
}

.link-qr-code {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.opt-link {
  color: #409EFF;
  margin-right: 5px;
  white-space: nowrap;
}

.link-mark {
  width: 100px;
  min-height: 23px;
}

.exp_box {
  width: 100%;
}

.exp_box .exp_title {
  width: 100%;
  height: auto;
  font-size: 14px;
  margin-bottom: 20px;
}

.exp_box .exp_head {
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
}

.exp_box .exp_head .lab {
  display: inline-block;
  width: auto;
  height: 40px;
  line-height: 40px;
  margin: 0 5px;
  vertical-align: top;
}

.exp_box .exp_head .sel {
  width: 160px;
}

.exp_box .exp_head .inp {
  margin-left: 10px;
}

.replace {
  width: 100%;
  height: auto;
}

.replace .item {
  width: 100%;
  height: 40px;
  line-height: 40px;
}

.replace .item .l {
  display: inline-block;
  width: 60px;
  height: 40px;
  vertical-align: top;
}

.replace .item .r {
  display: inline-block;
  width: 290px;
  height: 40px;
  vertical-align: top;
}

.exc_color {
  color: #f6ab16 !important;
}
</style>